import { useState, useEffect } from 'react';

import { useMutation, useQuery } from 'react-query';

import { chatgenieAPI } from 'src/config/api';
import { queryClient } from 'src/config/queryClient';
import queryKeys from 'src/constants/queryKeys';
import useToast from 'src/hooks/useToast';
import { extractServerErrorMessage } from 'src/utils';

const useTabs = () => {
  const { toast } = useToast();
  const [settings, setSettings] = useState({});

  const {
    data: res,
    isLoading,
    refetch
  } = useQuery([queryKeys.GET_AGENT_SETTINGS], () => chatgenieAPI.getAgentSettings(), {
    refetchOnMount: true
  });

  const { mutate, isLoading: isUpdating } = useMutation(
    ['updateAgentSettings'],
    data => chatgenieAPI.updateAgentSettings(data),
    {
      onSuccess: res => {
        toast.success('Settings updated successfully!');
        queryClient.setQueryData([queryKeys.GET_AGENT_SETTINGS], res.data);
      },
      onError: error => {
        refetch().then(({ data }) => setSettings(data));
        toast.error(`Failed to update agent's settings: ${extractServerErrorMessage(error)}`);
      }
    }
  );

  function updateAgentSettings(newSettings) {
    setSettings(old => ({
      ...old,
      ...newSettings
    }));
  }
  const saveAgentSettings = () => {
    mutate(settings);
  };

  useEffect(() => {
    if (res) {
      setSettings(res);
    }
  }, [res]);

  return {
    settings,
    agentEnabled: settings.enabled ?? false,
    updateAgentSettings,
    isLoading,
    saveAgentSettings,
    isUpdating
  };
};

export default useTabs;
